import Spinner from "@/components/Spinner";
import { Navigate } from "react-router-dom";
import { memo } from "react";
import { generatePath } from "react-router-dom";
import { usePayrollParams } from "../hooks/usePayrollParams";
import { usePayrollQuery } from "../hooks/usePayrollQuery";
import { usePayrollPermissions } from "../hooks/usePayrollPermissions";
import { PATH_PAYROLL } from "@/constants";
import { PayrollInspectionTable } from "./PayrollInspectionTable";

export const PayrollInspectionDirectory = memo(() => {
  const { payrollId } = usePayrollParams();
  const payrollQuery = usePayrollQuery(payrollId);
  const permissions = usePayrollPermissions();

  if (payrollQuery.isLoading) {
    return <Spinner className="w-full h-full" />;
  }

  if (!permissions.canAccessInspection) {
    return (
      <Navigate
        to={generatePath(PATH_PAYROLL, {
          payrollId,
        })}
        replace
      />
    );
  }

  if (!payrollQuery.data) {
    return null;
  }

  return (
    <PayrollInspectionTable
      payrollData={payrollQuery.data}
      payrollId={payrollId}
    />
  );
});
